<template>
  <div class="chartType-setting"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div 
      class="header" 
      @mousedown="moveStart($event, true)" 
      @mousemove="moveArea($event)" 
      @mouseup="saveMoveState($event)" 
      :style="{'cursor': 'move'}"
    >
      <span>
        <span 
          class="directionEffext_icon el-icon-back"
          v-if="directionEffext.type == 1"
          @click="directionEffext.type = 0"
        ></span>
      
        出入场动画
      </span>
      <i @click="close" class="icon-popup-close"></i>
    </div>

    <div class="effectBody" >
      <div class="switchType">
        <div 
          :class="{
            'active' : boxtype == 0,
          }"
          @click="switchBoxtype(0)"
        >
          入场动画
        </div>
        <div 
          :class="{
            'active' : boxtype == 1,
          }"
          @click="switchBoxtype(1)"
        >
          出场动画
        </div>
      </div>

      <transition name="bounce">
      <div 
        class="effectBox"
        v-if='directionEffext.type == 0'
      >
        <div 
          class="list__item"
          v-for="item in effectData.data"
          :class="{
            'no-anim' : item.type === 'noAnim', 
            ['icon-wrapper-' + (item.icon || item.type)]: true, 
          }"
          @click="settingSpritesEffect(item)"
          v-analysis="{
            category:'materCombination_enex_animation', 
            action:'click_' + item.type, 
            label:'素材组合_出入场动画_' + item.name,
          }"
        >
          <i 
            class="icon"
            :class="{
              'forbidden'  : !item.action,
              'is-out'     : boxtype == 1, 
              'activeIcon' : boxtype == 0 ? 
                (spritesType.entrEffct.code ? item.type.indexOf(spritesType.entrEffct.code) >= 0 : false) 
                  : 
                (spritesType.exitEffct.code ? item.type.indexOf(spritesType.exitEffct.code) >= 0 : false),
              ['icon-effect-' + (item.icon || item.type)]: true,
            }"
          ></i>
          
          <span class="title">
          
            {{item.name}}
          </span> 
        </div>
      </div>    
      </transition>
    
      <transition name="bounce">
      <div 
        class="directionEffext" 
        v-if='directionEffext.type == 1'
      >
        <div 
          v-if="
            directionEffext.dataType == 'LeftInRightInUpInDownIn' || 
            directionEffext.dataType == 'LeftOutRightOutUpOutDownOut'
          "
        >
          <div class="radios__title">
            动画速度
          </div>
          <ul class="radios__list">
            <li
              class="radios__item"
              v-for="(item, key) in directionEffext.easingList"
              :class="{
                active: (boxtype == 0) ? 
                  (item.alias == spritesType.entrEffct.alias) 
                    : 
                  (item.alias == spritesType.exitEffct.alias),
              }"
              :key="key"
              @click="settingSpritesEffect(item)"
            >
              <i></i>
              <span>{{item.text}}</span>
            </li>
          </ul>
        </div>

        <div class="list">
          <div class="list__title">
            动画方向
          </div>
          <ul class="list__items">
            <li
              class="list__item"
              v-for="(item, index) in directionEffext.data"
              :class="{
                active:  (boxtype == 0) ? 
                  ( 
                    (directionEffext.dataType == 'Smear') ? 
                      (item.direction == spritesType.entrEffct.direction) 
                        : 
                      (item.type == spritesType.entrEffct.code) 
                  ) 
                    : 
                  (
                    (directionEffext.dataType == 'Smear') ? 

                      (item.direction == spritesType.exitEffct.direction)
                        : 
                      (item.type == spritesType.exitEffct.code) 
                  ),
              }"
              :key="index"
              @click="settingSpritesEffect(item)"
            >
              <div 
                class="list__figure" 
                :class="{
                  [`icon-wrapper-${item.icon || item.to}`]: true
                }"
              >
                <i 
                  class="icon" 
                  :class="{
                    [`icon-effect-${item.icon || item.to}`]: true, 
                  }"
                ></i>
              </div>
              <div class="list__caption">{{item.text}}</div>
            </li>
          </ul>
        </div>
      </div>
      </transition>
    </div>

    <div 
      class="footBox"
      :class="{
        'activeHand' : !this.effextHand, 
      }"
      @click='settingHand()'
    >
      <i 
        class="icon-hand-hand"
      ></i>
      
      <span class="title">
        添加手势
      </span> 
    </div>
  </div>
</template>

<script>
// 多选元素出入场动画设置
import { mapGetters } from 'vuex'
import popup from '../mixins/popup'

export default {
  mixins: [popup],
  data() {
    return {
      spriteType: 'selectSpritesEffect',
      boxData  : {
        judgeBox : false, // 控制盒子开启关闭
        Zindex   : 0,     // 盒子层级
        data     : null,  // 盒子数据
        moveoks  : false, // 拖动判读啊数据
        oldMove  : {      // 计算移动增量
          x : 0,
          y : 0
        },
        fix : {           // 弹窗位置
          x : 0,
          y : 0
        }
      },
      boxtype  : 0,
      effectData : {  // 动画组合
        entr : [  // 入场动画
          {
            type   : 'None',
            name   : '无动画',
            icon    : 'noAnim',
            action : true,     // 显示不支持的状态
            spriteType : 0, // 0--通用动画 1--文字专用   2--svg专用  3--静态图专用
          },
          {
            type   : 'write',
            name   : '书写',
            icon    : '',
            action : true,
            spriteType : 1, 
          },
          {
            type   : 'appear',
            name   : '逐行出现',
            icon    : '',
            action : true,
            spriteType : 1, 
          },
          {
            type   : 'type',
            name   : '打字',
            icon    : '',
            action : true,
            spriteType : 1, 
          },
          {
            type   : 'Roll',
            name   : '滚入',
            icon    : 'roll',
            action : true,
            spriteType : 1, 
          },
          {
            type   : 'Bounce',
            name   : '弹跳',
            icon    : 'bounce',
            action : true,
            spriteType : 1, 
          },
          {
            type   : 'hand',
            name   : '手绘',
            icon    : '',
            action : false,
            spriteType : 2,
          },
          {
            type   : 'hand',
            name   : '涂抹',
            icon    : '',
            action : false, 
            spriteType : 3,
          },
          {
            type   : 'Draw',
            name   : '涂抹',
            icon    : 'write',
            action : false, 
            spriteType : 2,
          },
        ],
        baseEntr : [ // 通用入场动画
          {
            type   : 'Smear',
            name   : '擦入',
            icon    : 'smear-n',
            action : true,
            spriteType : 0,
          },
          {
            type   : 'LeftInRightInUpInDownIn',
            name   : '移入',
            icon    : 'left',
            action : true,
            spriteType : 0,
          },
          {
            type   : 'FadeIn',
            name   : '淡入',
            icon    : 'fade',
            action : true,
            spriteType : 0,
          },
          {
            type   : 'PopIn',
            name   : '放大出现',
            icon    : 'pop',
            action : true,
            spriteType : 0,
          },
        ],
        out : [ // 出场动画
          {
            type   : 'None',
            name   : '无动画',
            icon    : 'noAnim',
            action : true,     // 显示不支持的状态
            spriteType : 0, // 0--通用动画 1--文字专用   2--svg专用  3--静态图专用
          },
          {
            type   : 'Smear',
            name   : '擦除',
            icon    : 'smear-n',
            action : true,
            spriteType : 0,
          },
          {
            type   : 'LeftOutRightOutUpOutDownOut',
            name   : '移出',
            icon    : 'left',
            action : true,
            spriteType : 0,
          },
          {
            type   : 'FadeOut',
            name   : '淡出',
            icon    : 'fade',
            action : true,
            spriteType : 0,
          },
          {
            type   : 'PopOut',
            name   : '缩小退出',
            icon    : 'pop',
            action : true,
            spriteType : 0,
          },
        ],
        baseOut : [], // 通用出场动画
        data : [],  // 显示区域的动画
      }, 
      spritesType:{
        spritesNum : 0,  // 判断文字数量
        effectNum  : 0,  // 判断是否含有：路径、旋转、抖动、动态艺术字
        entrEffct  : {   // 入场动画
          code : '',
          direction : '',
          alias : '',
        },
        exitEffct  : {   // 出场动画
          code : '',
          direction : '',
          alias : '',
        },
      },
      directionEffext : { // 设置方向动画
        type    : 0, // 控制方向动画设置区域的开启关闭
        dataType: '',
        easingList: [
          {text: '加速', num: 1, alias: 'easeOutExpo'},
          {text: '减速', num: 2, alias: 'easeOutQuint'},
          {text: '匀速', num: 0, alias: 'linear'}
        ],
        rubIn   : [
          {text: '左擦入', long: '从左擦入', type: 'Smear', to: 'right', direction: 'e', icon: 'smear-e'},
          {text: '右擦入', long: '从右擦入', type: 'Smear', to: 'left', direction: 'w', icon: 'smear-w'},
          {text: '上擦入', long: '从上擦入', type: 'Smear', to: 'down', direction: 's', icon: 'smear-s'},
          {text: '下擦入', long: '从下擦入', type: 'Smear', to: 'up', direction: 'n', icon: 'smear-n'},
        ],
        rubOut  : [
          {text: '左擦除', long: '向左擦除', type: 'Smear', to: 'left', direction: 'w', icon: 'smear-w'},
          {text: '右擦除', long: '向右擦除', type: 'Smear', to: 'right', direction: 'e', icon: 'smear-e'},
          {text: '上擦除', long: '向上擦除', type: 'Smear', to: 'up', direction: 'n', icon: 'smear-n'},
          {text: '下擦除', long: '向下擦除', type: 'Smear', to: 'down', direction: 's', icon: 'smear-s'},
        ],
        moveIn  : [
          {text: '左移入', long: '从左移入', type: 'LeftIn', to: 'right', direction: '', active: false},
          {text: '右移入', long: '从右移入', type: 'RightIn', to: 'left', direction: '', active: false},
          {text: '上移入', long: '从上移入', type: 'UpIn', to: 'down', direction: '', active: false},
          {text: '下移入', long: '从下移入', type: 'DownIn', to: 'up', direction: '', active: false},
        ],
        moveOut : [
          {text: '左移出', long: '向左移出', type: 'LeftOut', to: 'left', direction: '', active: false},
          {text: '右移出', long: '向右移出', type: 'RightOut', to: 'right', direction: '', active: false},
          {text: '上移出', long: '向上移出', type: 'UpOut', to: 'up', direction: '', active: false},
          {text: '下移出', long: '向下移出', type: 'DownOut', to: 'down', direction: '', active: false},
        ],
        data    : [],
      },
      effextHand : false,
    }
  },
  props: ['dataMsg', 'boxDatas'],
  computed: {
    ...mapGetters([
      'TOOL',
      'TopNav_Size',
      'SelectSprites_Msg'
    ])
  },
  watch : {
    'boxDatas.firstDatas' : function(val, oldval){ // 判断打开关闭
      if(this.TOOL && this.boxData.judgeBox){ // 打开的操作
        this.boxData.data = this.dataMsg.selectSpritesEffect;
        this.boxData.Zindex = (this.dataMsg.length + 1)*5;
        this.boxData.fix.x  = this.dataMsg.selectSpritesEffect.posx+40;
        this.boxData.fix.y  = this.dataMsg.selectSpritesEffect.posy;
        this.boxtype = 0;
        this.directionEffext.type = 0;
        this.effextHand = false;
        this.spritesLoad();
      }
    },
    'spritesType.entrEffct.code':function(val, oldval){
      this.effextHandFS(val);
    },
    'spritesType.exitEffct.code':function(val, oldval){

      if(this.boxtype == 1){
        this.effextHandFS(val);
      }
    },
  },
  components: {
  },
  mounted() {
    
  },
  methods: {
    switchBoxtype(data){
      this.boxtype = data;
      let datalist = [];
      this.directionEffext.type = 0;
      switch(this.boxtype){
        case 0:
          for(let i = 0; i < this.effectData.entr.length; i++){
            let effect = this.effectData.entr[i];

            switch(effect.spriteType){ // 0--通用动画 1--文字专用 
              case 0:
                  datalist.push(effect);
                break;
              case 1:
                if(this.spritesType.spritesNum == 1){
                  if(this.spritesType.effectNum){
                    effect.action = false;
                  }else{
                    effect.action = true;
                  }
                  datalist.push(effect);
                }
                break;
              case 2:
                if(this.spritesType.spritesNum == 2){
                  if(this.spritesType.effectNum){
                    effect.action = false;
                  }else{
                    effect.action = true;
                  }
                  datalist.push(effect);
                }
                break;
              case 3:
                if(this.spritesType.spritesNum == 3){
                  if(this.spritesType.effectNum){
                    effect.action = false;
                  }else{
                    effect.action = true;
                  }
                  datalist.push(effect);
                }
                break;
            }         
          }
          this.effextHandFS(this.spritesType.entrEffct.code);
          datalist = datalist.concat(this.effectData.baseEntr);
          break;
        case 1:
          datalist = this.effectData.out;
          this.effextHandFS(this.spritesType.exitEffct.code);
          break;
      };
      this.effectData.data = datalist;
    },
    spritesLoad(){  // 元素加载梳理数据
      this.spritesType.spritesNum = '';
      this.spritesType.effectNum  = 0;
      this.spritesType.entrEffct.code = '';
      this.spritesType.entrEffct.alias= '';
      this.spritesType.entrEffct.direction= '';

      this.spritesType.exitEffct.code = '';
      this.spritesType.exitEffct.alias= '';
      this.spritesType.exitEffct.direction= '';
      
      let spriteType = '',
          thisEntrList = '',
          thisExitList = '';

      for(let i = 0; i < this.SelectSprites_Msg.length; i++){
        let sprite = this.SelectSprites_Msg[i],
            effect = this.SelectSprites_Msg[i].effect;
        
        spriteType = sprite.type;
        if(spriteType == 'Text'){
          spriteType = spriteType + sprite.artType + (sprite.font.textDecoration || '');
        }
        if(!this.spritesType.spritesNum){
          this.spritesType.spritesNum = spriteType;
        }else{

          if(this.spritesType.spritesNum != spriteType){
            this.spritesType.spritesNum = 100;
          }
        }

        let thisEntr = effect.code;
        if(effect.code.indexOf("In") >= 0){
          
          thisEntr = thisEntr + effect.easing
        }else if(effect.code == 'Smear'){

          thisEntr = thisEntr + effect.direction
        }
        if(!this.spritesType.entrEffct.code && !thisEntrList){
          this.spritesType.entrEffct.code = thisEntr;
          thisEntrList = thisEntr;
          if(effect.code.indexOf("In") >= 0){
            
            this.spritesType.entrEffct.code = effect.code;
            this.spritesType.entrEffct.alias= effect.easing;
          }else if(effect.code == 'Smear'){

            this.spritesType.entrEffct.code = effect.code;
            this.spritesType.entrEffct.direction= effect.direction;
          }
        }else{

          if(thisEntrList != thisEntr){
            this.spritesType.entrEffct.code  = '';
            this.spritesType.entrEffct.alias = '';
            this.spritesType.entrEffct.direction = '';
          }
        }

        let thisExit = effect.exitAnim.type;
        if(thisExit.indexOf("Out") >= 0){
          
          thisExit = thisExit + effect.exitAnim.easing
        }else if(thisExit == 'Smear'){

          thisExit = thisExit + effect.exitAnim.direction
        }
        if(!this.spritesType.exitEffct.code && !thisExitList){
          this.spritesType.exitEffct.code  = thisExit;
          thisExitList = thisExit;
          if(thisExit.indexOf("Out") >= 0){
          
            this.spritesType.exitEffct.code  = effect.exitAnim.type;
            this.spritesType.exitEffct.alias = effect.exitAnim.easing;
          }else if(thisExit == 'Smear'){

            this.spritesType.exitEffct.code  = effect.exitAnim.type;
            this.spritesType.exitEffct.direction = effect.exitAnim.direction;
          }
        }else{

          if(thisExitList != thisExit){
            this.spritesType.exitEffct.code  = '';
            this.spritesType.exitEffct.alias = '';
            this.spritesType.exitEffct.direction = '';
          }
        }


        switch(sprite.type ){
          case 'Text':
            if(sprite.artType){
              this.spritesType.effectNum += 1;
            }
            break;
        }
        switch(effect.stayAnim.type){
          case "Shake":
          case "Whirl":
            this.spritesType.effectNum += 1;
            break;
        }
      }
      switch(this.spritesType.spritesNum){
        case 'Image':
          this.spritesType.spritesNum = 3;
          break;
        case 'Svg':
          this.spritesType.spritesNum = 2;
          break;
        case 'Text':
          this.spritesType.spritesNum = 1;
          break;
        default: 
          this.spritesType.spritesNum = 100;
          break;
      }
      this.switchBoxtype(this.boxtype);
    },
    settingSpritesEffect(data){ // 设置元素
      if(data.type == 'LeftInRightInUpInDownIn' || data.type == 'LeftOutRightOutUpOutDownOut' || (!data.to && data.type == 'Smear')){
        this.directionEffext.type = 1;
        this.directionEffext.dataType = data.type;
        this.switchDirectionEffect();
        return;
      }
      this.SelectSprites_Msg.forEach(sprite => {

        if(this.boxtype == 0){

          if(!data.type){
            
            if(
              !this.spritesType.entrEffct.code || 
              'LeftInRightInUpInDownIn'.indexOf(this.spritesType.entrEffct.code) < 0
            ){
              data.type = 'LeftIn';
            }else{
              data.type = this.spritesType.entrEffct.code;
            }
          }

          let {start, end} = sprite.effect.entranceAnim;

          if (data.type === 'None') {
            start = end;
          } else {
            start = Math.max(end - 500, 0);
          }
          let entrAnimData = {
            code : data.type,
            entranceAnim: {
              start,
              end
            }
          };
          if(sprite.type == 'Text' && data.type == 'hand'){
            entrAnimData.code = 'write';
          }
          if(this.directionEffext.dataType == 'LeftInRightInUpInDownIn'){
            entrAnimData.easing = this.spritesType.entrEffct.alias || 'easeOutExpo';
          }
          if(data.direction) entrAnimData.direction = data.direction;
          if(data.alias) entrAnimData.easing = data.alias;

          sprite.updateEffect(entrAnimData, true);

          this.spritesType.entrEffct.code = entrAnimData.code;
          this.spritesType.entrEffct.alias= entrAnimData.easing;
          this.spritesType.entrEffct.direction= entrAnimData.direction;
        }else if(this.boxtype == 1){

          if(!data.type){
            
            if(
              !this.spritesType.exitEffct.code && 
              'LeftOutRightOutUpOutDownOut'.indexOf(this.spritesType.exitEffct.code) < 0
            ){
              data.type = 'LeftOut';
            }else{
              data.type = this.spritesType.exitEffct.code;
            }
          }
          
          let {start, end} = sprite.effect.exitAnim;

          if (data.type == 'None') {
            end = start;
          } else {
            if(start >= this.TOOL.selectedScenes.duration) {
              start = this.TOOL.selectedScenes.duration - 500;
            }
            end = Math.min(start + 500, this.TOOL.selectedScenes.duration);
          }
          let exitAnimData = {
              type: data.type,
              start,
              end
          };
          if(this.directionEffext.dataType == 'LeftOutRightOutUpOutDownOut'){
            exitAnimData.easing = this.spritesType.exitEffct.alias || 'easeOutExpo';
          }
          if(data.direction) exitAnimData.direction = data.direction;
          if(data.alias) exitAnimData.easing = data.alias;

          sprite.updateEffect({
            exitAnim : exitAnimData
          }, true);

          this.spritesType.exitEffct.code = exitAnimData.type;
          this.spritesType.exitEffct.alias= exitAnimData.easing;
          this.spritesType.exitEffct.direction= exitAnimData.direction;
        }
      });

    },
    switchDirectionEffect(){
      this.directionEffext.data = [];
      switch(this.directionEffext.dataType){
        case 'LeftInRightInUpInDownIn':
          this.directionEffext.data = this.directionEffext.moveIn;
          break;
        case 'LeftOutRightOutUpOutDownOut':
          this.directionEffext.data = this.directionEffext.moveOut;
          break;
        case 'Smear':
          if( this.boxtype == 0 ){
            this.directionEffext.data = this.directionEffext.rubIn;
          }else{
            this.directionEffext.data = this.directionEffext.rubOut;
          }
          break;
      }
    },
    stopDocument(e){      // 防止事件冒泡
      e.stopPropagation();
      e.preventDefault();
    },
    effextHandFS(data){
      if(
        'LeftInRightInUpInDownIn'.indexOf(data) >= 0 || 
        'LeftOutRightOutUpOutDownOut'.indexOf(data) >= 0 ||
        'write'.indexOf(data) >= 0 ||
        'hand'.indexOf(data) >= 0 
      ){

        this.effextHand = true;
      }else{

        this.effextHand = false;
      }
    },
    settingHand(){
      if(!this.effextHand)return;
      let modalName = 'hand',
          name = 'in';
      if(this.boxtype == 0){
        
        if(this.spritesType.entrEffct.code == 'write'){
          modalName = 'writehand';
        }else{
          modalName = 'hand'
        }
      }else{
        name = 'out'
      }
      this.$bus.emit('Modal_vue', {
        name: modalName, // 'writehand' : 'hand'
        type: modalName, // 'writehand' : 'hand'
        data: {
          inout: name, // 'in' : 'out'
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors";

.chartType-setting {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  min-height: 500px;
  z-index: 35;
  background: #fff;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px 
		rgba(54, 76, 204, 0.4);
	border-radius: 8px;
  box-sizing: border-box;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 15px;
    height: 28px;
    background-color: #d9ddea;

    .directionEffext_icon{
      cursor: pointer;
    }
    span {
      color: #474261;
    }
    i {
      display: inline-block;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }

  .effectBody{
    height: 420px;
    overflow: hidden;
    overflow: hidden;
    .switchType{
      display: flex;
      justify-content: space-around;
    	height: 34px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #474261;
      
      >div{
        line-height: 34px;
        width: 130px;
	      background-color: #f8f8fc;
        overflow: hidden;
      }
      .active{
        color: #ffffff;
        background-color: #5778fb;
        position: relative;
        &:before{
          display: block;
          content: '';
          border-width: 0 4px 6px 4px;
          border-style: solid;
          border-color: transparent transparent #ffffff transparent;
          position: absolute;
          left: 62px;
          bottom: 0;
        }
      }
    }

    .effectBox{
      height: 400px;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      align-content: baseline;

      >div{
        height: 86px;
        width: 60px;
        margin: 15px 0 0 20px;
        
        .icon{
          position: relative;
          display: block;
          height: 60px;
          width: 60px;
          border: 1px solid #eff1f8;
          border-radius: 4px;
          background-color: #eff1f8;
          overflow: hidden;
          margin-bottom: 5px;
        }
        .forbidden{
          background-color: #7c7d80;
        }
        .activeIcon{
          border: 1px solid #5778fb;
          box-shadow: 0 0 0 0.5px #5778fb;
        }
        &.no-anim {
          > i {
            position: relative;
            overflow: hidden;
            &:before {
              content: " ";
              position: absolute;
              height: 1px;
              width: 110px;
              background-color: red;
              transform: rotate(-45deg) translatex(-60px) translatey(-19px);
            }
          }
        }
      }
    }
  
    .directionEffext{
      height: 400px;
      padding: 15px;
      overflow: hidden;

      .radios {
        padding-left: 20px;
        padding-right: 20px;
        margin-top: 15px;
        margin-bottom: 13px;

        &__title {
          margin-bottom: 10px;
          font-size: 14px;
          text-align-last: left;
        }

        &__list {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        &__item {
          display: flex;
          align-items: center;
          font-size: 14px;
          cursor: pointer;

          &>i {
            width: 16px;
            height: 16px;
            border-radius: 16px;
            border: solid 1px #9692a9;
          }
          &>span {
            padding-left: 5px;
          }

          &.active>i {
            background-color: #9692a9;
            box-shadow: 0 0 0 2px #ffffff inset;
          }
        }
      }
      .list {
        margin-top: 33px;

        &:first-child {
          margin-top: 0;
        }

        &__title {
          margin-bottom: 13px;
          font-size: 14px;
          text-align-last: left;
        }

        & > ul {
          display: flex;
          // flex-wrap: wrap;
        }
        &__items {
          width: 226px;
          justify-content: space-between;
          margin-left: -4px;
        }
        &__item {
          margin-right: 6px;
          margin-bottom: 15px;
          cursor: pointer;

          &:nth-child(4n) {
            margin-right: 0;
          }

          &.active .list__figure {
            box-shadow: 0 0 0 2px $c2;
          }
        }
        &__figure {
          width: 50px;
          height: 50px;
          background-color: #f0f0f8;
          border-radius: 4px;
          overflow: hidden;
        }
        &__caption {
          margin-top: 7px;
        }
      }
    }
  }

  .footBox{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 260px;
    height: 36px;
    background-color: #f0f0f8;
    border-radius: 0px 0px 8px 8px;
    cursor: pointer;

    >i{
      margin-right: 5px;
    }
  }
  .activeHand{
    &:before{
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.7);
    }
  }
}
.icon-effect-noAnim:before {
    content: " ";
    position: absolute;
    height: 1px;
    width: 110px;
    background-color: red;
    transform: rotate(-45deg) translatex(-60px) translatey(-19px);
}
.bounce-enter-active {
  animation: bounce-in .3s;
}
.bounce-leave-active {
  animation: bounce-in .3s reverse;
}
@keyframes bounce-in {
  0% {
    background: #fff;
    height: 0px;
  }
  100% {
    background: #fff;
    height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/selectSpritesEffect.vue